import { MapTo } from '@adobe/aem-react-editable-components';
import TermsTable, { TermsTableEditConfig } from './TermsTable';

export default MapTo('cob-corp-acquisition/components/creditonebank/terms-table')(TermsTable, TermsTableEditConfig);